module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ce-Da-Ea.fe658dc3.png";